
import WebFont from 'webfontloader'

const options = {"google":{"families":["Open+Sans","Oswald"]}}

WebFont.load(options)
